export const toFixedDown = (value: number, precision: number): string => {
	return (Math.floor(value * (10**precision)) / (10**precision)).toFixed(precision);
}